import { Resource } from 'app/shared/acl/acl.model';
import { Geometry } from 'app/shared/ll/models/geometry';
import { Style } from 'app/shared/ll/models/style';


export const LEGEND_LABEL_MIN_ZOOM = 15;


interface BaseLayerDef {
    type: string;
    key: string;
    parent: string | null;
    title: string;
    description: string;
    aclResourceName: Resource | null;
}

export interface LegendItem {
    src: string;
    iconId: string;
    title: string;
}

export interface OutlineScaleStop {
    zoom: number;
    weight: number;
}

export interface OutlineScaling {
    type: 'step';
    stops: OutlineScaleStop[];
}

interface ILayerDef extends BaseLayerDef {
    type: 'Layer';
    updating?: boolean;
    minZoom?: number;
    options?: any;
    legend?: LegendItem[];
    disclaimer?: string;
    optionsComponent?: string;
    bubbleComponent: string | null;
    lockComponent?: string;
    new?: boolean;
    maintenance?: boolean;
    disabled?: boolean;
    credentials: string | null;
    attribution?: string;
    hiddenForAclResourceName: Resource | null;
    outlineScaling?: OutlineScaling;
}

export type LayerDef = Readonly<ILayerDef>;

interface ILayerGroupDef extends BaseLayerDef {
    type: 'Group';
    new?: boolean;
}

export type LayerGroupDef = Readonly<ILayerGroupDef>;

export type LayerItemDef = LayerDef | LayerGroupDef;

export function isLayerDef(layerItemDef: LayerItemDef): layerItemDef is LayerDef {
    return layerItemDef.type === 'Layer';
}

export function isLayerGroupDef(layerItemDef: LayerItemDef): layerItemDef is LayerGroupDef {
    return layerItemDef.type === 'Group';
}

interface IFeature<T = Geometry> {
    id: string;
    legendLabel: string;
    type: 'Feature';
    properties: Record<string, unknown>;
    geometry: T;
    bubbleContent: string;
    tableContent: any;
    style: Style;
}

export type Feature<T = Geometry> = Readonly<IFeature<T>>;

export interface BrokerListingsFeature extends Feature {
    tableContent: {
        header: string;
        address: string;
        detailUrl: string;
        mlsNumber: string;
        opportunityType: string;
        brokerName: string;
        size: string;
        leaseRate: string;
        salePrice: string;
        description: string;
    };
}

export interface Layer {
    key: string;
    features: Feature[];
}


export interface AvailableLayer {
    layerKey: string;
    hasCredentials: boolean;
    withinBounds: boolean;
    zoomSatisfied: boolean;
}

export interface SelectedLayers {
    [layerKey: string]: {
        args?: Record<string, any>;
        updating: boolean;
    };
}

export interface LayerSelection {
    key: string;
    updating: boolean;
    args?: any;
}
